import { Component } from "react"
import PropTypes from "prop-types"
import "./platform_edit_field.scss"
import cn from "classnames"

export default class PlatformEditField extends Component {
  render() {
    return (
      <div
        styleName={cn("edit-field-container", {
          "selectable-field":
            this.props.fieldCallback && this.props.fieldEnabled,
        })}
        className="edit-field-container"
        onClick={this.props.fieldCallback && this.props.fieldCallback}
      >
        {this.props.title}
        <span styleName="button-container" className="button-container">
          {this.props.actions &&
            this.props.fieldEnabled &&
            this.props.actions.map((action, key) => {
              return (
                <span
                  styleName={`edit-field-button ${
                    key == this.props.actions.length - 1 ? "final-button" : ""
                  }`}
                  className="edit-field-button"
                  key={key}
                  onClick={action.callback}
                  dangerouslySetInnerHTML={{ __html: action.icon }}
                />
              )
            })}
        </span>
      </div>
    )
  }
}

PlatformEditField.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.object),
  fieldEnabled: PropTypes.bool,
  fieldCallback: PropTypes.func,
}

PlatformEditField.defaultProps = {
  fieldEnabled: true,
}
